import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseApi } from './base-api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AuthService {

  applicant: any;
  applicantID: string;

  private baseUrl = '/users';

  constructor(
    private api: BaseApi,
    private snackbar: MatSnackBar
  ) { }

  logout() {
    this.applicant = null;
    sessionStorage.removeItem('wl-applicant-id');
    sessionStorage.removeItem('wl-custId');
    sessionStorage.removeItem('wzbvdsjvbbs');
    sessionStorage.clear();
  }

  loggedIn() {
    return sessionStorage.getItem('wl-applicant-id') ? true : false;
  }

  registerUser(user) {
    return this.api.newPost(`${this.baseUrl}/register`, user).pipe(map(user => 'Registration Successful'));
  }

  sendOTP(mobileNo) {
    return this.api.newPost(`${this.baseUrl}/otp`, { mobileNo: mobileNo })
      .pipe(
        catchError(err => {
          this.snackbar.open(err.message, 'OK', { duration: 3000 });
          return of(err.message);
        })
      );
  }

  userLogin(badWord, custId) {
    // newPost
    return this.api.postRes(`${this.baseUrl}/auth`, { prd: badWord, custId: custId })
      .pipe(map(applicant => {
        console.log('Login Data: ', applicant);

        if (applicant['copplicant'] && applicant['copplicant'].length > 0) {
          console.log("applicant['copplicant'][0] " + applicant['copplicant'][0]['id']);
          sessionStorage.setItem('wl-cust-applicant-id', applicant['copplicant'][0]['id']);
        } else {
          sessionStorage.setItem('wl-cust-applicant-id', "");
        }
        if (applicant && applicant['success']) {
          if (applicant['result']) {
            this.storeApplicant(applicant['result']);
            return applicant['result'];
          }

        } else {
          this.snackbar.open(applicant['message'], 'OK', { duration: 3000 });
          throw applicant;
        }


      }));
  }

  checkPaymentStatus(custId, paymentId) {
    return this.api.postRes(`${this.baseUrl}/getPaymentStatus`, { custId: custId, paymentId: paymentId })
      .pipe(map(res => {
        return res;
      }));
  }

  private storeApplicant(applicant) {
    // sessionStorage.setItem('wl-applicant', JSON.stringify(applicant));
    // sessionStorage.setItem('wl-applicant-id', applicant.id);
    sessionStorage.setItem('wl-custId', applicant.custId);
    sessionStorage.setItem('wl-ydl-id', applicant.yodleeUserId);
    this.applicant = applicant;
    this.applicantID = applicant.id;
  }

  getRoleStatus() {
    var role = sessionStorage.getItem('wzbvdsjvbbs');
    if (role == "4dfb05e4-ca35-492b-8a6a-0e0775426090" || role == "6a66230a-ccbf-11ea-87d0-0242ac130003") {
      return true
    } else {
      return false
    }
    // return sessionStorage.getItem('wzbvdsjvbbs');
  }

}
